<script setup lang="ts">
const props = defineProps<{ duration: number }>();
const emit = defineEmits(['finished']);

const progress = ref(props.duration);
let intervalId: number | undefined;

const startCountdown = () => {
  if (intervalId) clearInterval(intervalId);
  progress.value = props.duration;
  intervalId = window.setInterval(() => {
    if (progress.value > 0) {
      progress.value -= 100;
      if (progress.value <= 0) {
        progress.value = 0;
        emit('finished');
        clearInterval(intervalId);
      }
    }
  }, 100);
};

const progressPercentage = computed(
  () => (progress.value / props.duration) * 100,
);

onMounted(startCountdown);
onUnmounted(() => {
  if (intervalId) clearInterval(intervalId);
});

watch(() => props.duration, startCountdown);
</script>
<template>
  <div class="generic-countdown-bar w-full">
    <!--    <progress class="w-full h-1 rounded-lg" :value="progress" :max="duration" />-->
    <div class="custom-progress-bar h-1 rounded-lg w-full bg-dark-700">
      <div
        class="progress-fill bg-primary-blue-gradient h-full"
        :style="{ width: `${progressPercentage}%` }"
      ></div>
    </div>
  </div>
</template>

<style scoped>
progress {
  accent-color: red; /* Or any other color value like #00ff00, hsl(120, 100%, 50%) */
}

.progress-fill {
  transition: width 0.5s ease-in-out;
}
</style>
